/**
 * Shared types for Google Places API integration
 */

export interface PlaceDetails {
  address1: string;
  address2: string | null;
  city: string;
  country: string;
  formattedAddress: string;
  name: string | null;
  placeId: string;
  plusCodeGlobal: string | null;
  postalCode: string;
  state: string;
  center: {
    lat: number;
    lng: number;
  };
  boundingBox: {
    northeast: {
      lat: number;
      lng: number;
    };
    southwest: {
      lat: number;
      lng: number;
    };
  };
}

export interface GeolocationResult {
  coords: {
    latitude: number;
    longitude: number;
  };
  address: PlaceDetails | null;
}

/**
 * Format address components into a standard format
 */
export function formatAddress(
  address1: string,
  address2: string | null,
  city: string,
  state: string,
  postalCode: string,
): string {
  const combinedAddress = address2 ? `${address1} ${address2}` : address1;
  return `${combinedAddress} ${city}, ${state} ${postalCode}`;
}
